import React from 'react';

import CompsForm from './CompsForm';
import Summary from '../Summary';
import { isMobile } from '../../../../../lib/getDeviceSize';

import styles from '../../../../../styles/sass/components/CompsChomper.module.scss';

interface Props {
  excludedListings: any[];
  hideSearchButton?: boolean;
  initialFormState: any;
  listing: any;
  loading: boolean;
  onNewSearchPress: Function;
  onSubmit: Function;
  soldComps: any;
  startWithActiveComps: boolean;
  transparent?: boolean;
}

export class CompsRangeForm extends React.Component<Props> {
  render() {
    return (
      <div
        className={styles.compsRangeContainer}
        style={{
          width: '100%',
          backgroundColor: this.props.transparent ? 'transparent' : '#f4f4f4',
        }}
      >
        {!isMobile() && (
          <Summary
            isSummaryOpen={false}
            handleSummaryToggle={() => null}
            listing={this.props.listing}
            loading={this.props.loading}
            soldComps={this.props.soldComps}
          />
        )}
        <CompsForm
          hideSearchButton={this.props.hideSearchButton}
          excludedListings={this.props.excludedListings}
          initialFormState={this.props.initialFormState}
          listing={this.props.listing}
          onNewSearchPress={this.props.onNewSearchPress}
          onSubmit={this.props.onSubmit}
          startWithActiveComps={this.props.startWithActiveComps}
        />
      </div>
    );
  }
}

export default CompsRangeForm;
